import blast from "./assets/blast.png";
import tv from "./assets/tv.png";
import premier from "./assets/premier.png";
import major from "./assets/major.png";
import slam from "./assets/slam.png";

export const games = [
  {
    id: "blast",
    name: "BLAST",
    image: blast,
  },
  {
    id: "blasttv",
    name: "BLAST.TV",
    image: tv,
  },
  {
    id: "premier",
    name: "BLAST PREMIER",
    image: premier,
  },
  {
    id: "blasttv-major",
    name: "BLAST.tv Austin Major",
    image: major,
  },
  {
    id: "slam",
    name: "BLAST SLAM",
    image: slam,
  },
];
